/**
 * Do NOT reorder this list ...
 * unless you intend to change the order in which the cart is continued.
 */
export const cartFlowSequence = [
  {
    errorPage: "Cart",
    path: "/purchases",
    hash: "",
    continueText: "mk-hc-continue-to-cart-purchases",
  },
  // redundant `errorPage` definition for typescript help on `path`
  {
    // `Cart` means you can advance further within the same `errorPage`
    errorPage: "Cart",
    path: "/samples",
    hash: "",
    continueText: "continue to samples not expected",
  },
  {
    errorPage: "SampleUserRegistration",
    path: "/sample-user-registration",
    hash: "",
    continueText: "Continue to Sample Questions",
  },
  {
    errorPage: "SampleQuestions",
    path: "/sample-questions",
    hash: "",
    continueText: "mk-hc-continue-to-samples",
  },
  {
    errorPage: "ShippingAddress",
    path: "/address",
    hash: "",
    continueText: "mk-hc-continue-to-address",
  },
  {
    errorPage: "ShippingAddressExport",
    path: "/address",
    hash: "",
    continueText: "mk-hc-continue-to-address",
  },
  {
    errorPage: "ShippingOption",
    path: "/shipping",
    hash: "",
    continueText: "mk-hc-continue-to-shipping",
  },
  {
    errorPage: "BillingAddress",
    path: "/payment/billing",
    hash: "",
    continueText: "mk-hc-continue-to-payment-billing",
  },
  {
    errorPage: "Payment",
    path: "/payment/card/entry",
    hash: "",
    continueText: "mk-hc-continue-to-payment-card-entry",
  },
  {
    errorPage: "PaymentSaved",
    path: "/payment/card/saved",
    hash: "",
    continueText: "mk-hc-continue-to-payment-card-saved",
  },
  {
    errorPage: "Confirmation",
    path: "/confirm",
    hash: "",
    continueText: "mk-hc-continue-to-confirm",
  },
  {
    errorPage: "Success",
    path: "/success",
    hash: "",
    continueText: "mk-hc-submit-order",
  },
] as const;

export type CartRoute = typeof cartFlowSequence[number]["path"];
